export function stringifySlateContent(content: unknown): string {
    if (!content) {
        return '';
    }
    if (Array.isArray(content)) {
        return content
            .map((x) => stringifySlateContent(x))
            .map((x) => x.trim())
            .filter(Boolean)
            .join(' ');
    }
    if (typeof content === 'string') {
        return content;
    }
    if (typeof content === 'object' && 'text' in content && typeof content.text === 'string') {
        return content.text;
    }
    if (typeof content === 'object' && 'children' in content && Array.isArray(content.children)) {
        return stringifySlateContent(content.children);
    }
    return '';
}
